export default "__VITE_ASSET__DYGaXodI__"